import React, { Fragment, Component } from 'react'
import {
    FormGroup,
    Separator,
    KioskSelection,
    ActionLink,
} from './MenuSettings'
import PropTypes from 'prop-types'
import Loader from '../../components/Loader/Loader'
import { DebounceInput } from 'react-debounce-input'
import {
    MongoSites,
    MongoPointsOfSale,
    MongoTypeGuests,
    MongoTypeMeals,
    MongoMenus,
    MongoTypeRecipes,
} from '../../utils/mongo_utils'
import PicturePicker from '../../components/PicturePicker/PicturePicker'
import styled from 'styled-components'
import { SAVED_RECIPES_PICTURES_WINREST } from './AdminPanel'
import themes from 'themes'
import Checkbox from '../../components/Checkbox'
import Settings from 'settings'
import { getLanguage } from '../../utils/Locale'

class WinrestForm extends Component {
    state = {}

    componentDidMount() {
        this.searchDb(this.props)
    }

    async componentWillReceiveProps(nextProps) {
        this.searchDb(nextProps)
    }

    searchDb = props => {
        const { pointOfSaleSlug, mealTypeSlug, menuSlug, guestTypeSlug } = props

        const sitesList = MongoSites.find({}, { sort: 'name' })
        const pointsOfSaleList = MongoPointsOfSale.find({}, { sort: 'name' })
        const typeGuestsList = MongoTypeGuests.find(
            { pointOfSaleSlugs: { [pointOfSaleSlug]: true } },
            { sort: 'name' }
        )
        const mealTypesList = MongoTypeMeals.find(
            { pointOfSaleSlugs: { [pointOfSaleSlug]: true } },
            { sort: 'name' }
        )
        const menusList = MongoMenus.find(
            {
                pointOfSaleSlugs: { [pointOfSaleSlug]: true },
                mealTypeSlug,
                guestTypeSlug,
            },
            { sort: 'name' }
        )
        const recipeTypesList = MongoTypeRecipes.find(
            {
                menuSlugs: { [menuSlug]: true },
            },
            { sort: 'name' }
        )

        this.setState({
            sitesList,
            pointsOfSaleList,
            typeGuestsList,
            mealTypesList,
            menusList,
            recipeTypesList,
        })
    }

    render() {
        const {
            winrestURL,
            pointOfSaleSlug,
            siteId,
            date,
            forceToday,
            loading,
            handleChange,
            useCommercialName,
            language,
            uiLanguage,
            winrestLanguage,
            guestTypeSlug,
            mealTypeSlug,
            menuSlug,
            displayMode,
            zoom,
            orientation,
            size,
            days,
            print,
            openPrintDialog,
            displayModes,
            dayCount,
            hideMenuPrice,
            hideRecipePoints,
            hideComposition,
            hideLabels,
            isDuoKiosk,
            startDay,
            concepts,
            concept,
            recipes = [],
            generateUrl,
            title,
            subtitle,
            showDate,
            setExcludedDays,
        } = this.props
        const {
            sitesList = [],
            pointsOfSaleList = [],
            typeGuestsList = [],
            mealTypesList = [],
            menusList = [],
            recipeTypesList = [],
        } = this.state

        const defaultTitle = Settings.translations[getLanguage(language)].today

        return (
            <Fragment>
                <FormGroup>
                    <label>Winrest URL:</label>
                    <input
                        value={winrestURL}
                        name="winrestURL"
                        onBlur={handleChange}
                        onChange={handleChange}
                    />
                    <div />
                    <small>ex: wrfr.newrest.eu </small>
                </FormGroup>
                {!!winrestURL &&
                    sitesList.length > 0 &&
                    winrestURL.indexOf('.newrest.eu') !== -1 && (
                        <Fragment>
                            <FormGroup>
                                <label>Site:</label>
                                <select
                                    name="siteId"
                                    value={siteId}
                                    onChange={handleChange}
                                >
                                    <option value="">CHOOSE A SITE</option>
                                    {sitesList.map((singleSite, index) => (
                                        <option
                                            value={singleSite.id}
                                            key={index}
                                        >
                                            {singleSite.name}
                                        </option>
                                    ))}
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <label>Concept:</label>
                                <select
                                    name="concept"
                                    value={concept}
                                    onChange={handleChange}
                                >
                                    {concepts.map((concept, index) => (
                                        <option
                                            value={concept.code}
                                            key={index}
                                        >
                                            {concept.name}
                                        </option>
                                    ))}
                                </select>
                            </FormGroup>
                            <FormGroup>
                                <label>Date:</label>
                                <input
                                    name="date"
                                    type="date"
                                    value={date}
                                    onChange={handleChange}
                                    disabled={forceToday}
                                />
                            </FormGroup>
                            <FormGroup title="The link will be generated with the {today} token to automatically display the menu of the current day">
                                <label>Current date:</label>
                                <div>
                                    <Checkbox
                                        name="forceToday"
                                        type="checkbox"
                                        value={forceToday}
                                        checked={forceToday}
                                        onAction={handleChange}
                                    />
                                </div>
                            </FormGroup>
                        </Fragment>
                    )}
                {!!pointsOfSaleList.length && siteId && (
                    <FormGroup>
                        <label>Point Of Sale:</label>
                        <select
                            name="pointOfSaleSlug"
                            value={pointOfSaleSlug}
                            onChange={handleChange}
                        >
                            <option value="">CHOOSE A DELIVERY</option>
                            {pointsOfSaleList.map(
                                (singlePointOfSale, index) => (
                                    <option
                                        value={singlePointOfSale.slug}
                                        key={index}
                                    >
                                        {singlePointOfSale.name}
                                    </option>
                                )
                            )}
                        </select>
                    </FormGroup>
                )}
                {siteId && pointOfSaleSlug && winrestURL && (
                    <>
                        <FormGroup>
                            <label>Language:</label>
                            <select
                                name="uiLanguage"
                                value={uiLanguage}
                                onChange={handleChange}
                            >
                                <option value="en">English</option>
                                <option value="es">Español</option>
                                <option value="fr">Français</option>
                                <option value="tr">Türk</option>
                                <option value="pt">Português</option>
                                <option value="el">Greek</option>
                            </select>
                        </FormGroup>
                        <FormGroup>
                            <label>Recipe name:</label>
                            <select
                                name="winrestLanguage"
                                value={winrestLanguage}
                                onChange={handleChange}
                            >
                                <option value="commercialName1">
                                    COMMERCIAL NAME 1
                                </option>
                                <option value="commercialName2">
                                    COMMERCIAL NAME 2
                                </option>
                            </select>
                        </FormGroup>
                    </>
                )}
                {siteId && pointOfSaleSlug && winrestURL && language && (
                    <FormGroup>
                        <label>Guest Type:</label>
                        <select
                            name="guestTypeSlug"
                            value={guestTypeSlug}
                            onChange={handleChange}
                        >
                            <option value="">CHOOSE A GUEST TYPE</option>
                            {typeGuestsList.map((singleTypeGuest, index) => (
                                <option
                                    value={singleTypeGuest.slug}
                                    key={index}
                                >
                                    {singleTypeGuest.name}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                )}
                {siteId &&
                    pointOfSaleSlug &&
                    winrestURL &&
                    language &&
                    guestTypeSlug && (
                        <FormGroup>
                            <label>Meal Type:</label>
                            <select
                                name="mealTypeSlug"
                                value={mealTypeSlug}
                                onChange={handleChange}
                            >
                                <option value="">CHOOSE A MEAL TYPE</option>
                                {mealTypesList.map((singlemealType, index) => (
                                    <option
                                        value={singlemealType.slug}
                                        key={index}
                                    >
                                        {singlemealType.name}
                                    </option>
                                ))}
                            </select>
                        </FormGroup>
                    )}
                {siteId &&
                    pointOfSaleSlug &&
                    winrestURL &&
                    language &&
                    guestTypeSlug &&
                    mealTypeSlug && (
                        <FormGroup>
                            <label>Menu:</label>
                            <select
                                name="menuSlug"
                                value={menuSlug}
                                onChange={handleChange}
                            >
                                <option value="">CHOOSE A MENU</option>
                                {menusList.map((singleMenu, index) => (
                                    <option value={singleMenu.slug} key={index}>
                                        {singleMenu.name}
                                    </option>
                                ))}
                            </select>
                        </FormGroup>
                    )}
                {siteId &&
                    pointOfSaleSlug &&
                    winrestURL &&
                    language &&
                    guestTypeSlug &&
                    mealTypeSlug &&
                    menuSlug &&
                    menusList &&
                    menusList.length && (
                        <>
                            <FormGroup>
                                <label>Title:</label>
                                <input
                                    name="title"
                                    type="title"
                                    value={title}
                                    onChange={handleChange}
                                    placeholder={defaultTitle}
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Sub title:</label>
                                <input
                                    name="subtitle"
                                    type="subtitle"
                                    value={subtitle}
                                    onChange={handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>hide menu price:</label>
                                <div>
                                    <Checkbox
                                        name="hideMenuPrice"
                                        type="checkbox"
                                        checked={hideMenuPrice}
                                        onAction={handleChange}
                                    />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <label>hide calories:</label>
                                <div>
                                    <Checkbox
                                        name="hideRecipePoints"
                                        type="checkbox"
                                        checked={hideRecipePoints}
                                        onAction={handleChange}
                                    />
                                </div>
                            </FormGroup>
                        </>
                    )}

                {siteId &&
                    pointOfSaleSlug &&
                    winrestURL &&
                    language &&
                    guestTypeSlug &&
                    mealTypeSlug &&
                    menuSlug && (
                        <Fragment>
                            <FormGroup>
                                <label>USE RECIPE TYPE NAME:</label>
                                <div>
                                    <Checkbox
                                        name="useCommercialName"
                                        type="checkbox"
                                        checked={useCommercialName}
                                        onAction={handleChange}
                                    />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <label>HIDE COMPOSITION:</label>
                                <div>
                                    <Checkbox
                                        name="hideComposition"
                                        type="checkbox"
                                        checked={hideComposition}
                                        onAction={handleChange}
                                    />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <label>HIDE LABELS:</label>
                                <div>
                                    <Checkbox
                                        name="hideLabels"
                                        type="checkbox"
                                        checked={hideLabels}
                                        onAction={handleChange}
                                    />
                                </div>
                            </FormGroup>
                            {displayMode === 'kiosk' && (
                                <FormGroup>
                                    <label>Duo Kiosk:</label>
                                    <div>
                                        <Checkbox
                                            name="isDuoKiosk"
                                            type="checkbox"
                                            checked={isDuoKiosk}
                                            onAction={handleChange}
                                        />
                                    </div>
                                </FormGroup>
                            )}
                            <label>Recipe Type:</label>
                            <KioskSelection nogrid>
                                {concept && (
                                    <PicturePicker
                                        concept={concept}
                                        handleChange={handleChange}
                                        open={this.state.pickReciPic}
                                        useCommercialName={useCommercialName}
                                        close={() =>
                                            this.setState({
                                                pickReciPic: null,
                                            })
                                        }
                                    />
                                )}
                                {recipeTypesList.map((item, index) => {
                                    const name = recipes.find(
                                        recipe =>
                                            recipe.indexOf(`${item.slug}-`) > -1
                                    )
                                    const isChecked = recipes.indexOf(name) > -1
                                    const handleCheckbox = e => {
                                        const typedRecipesPics =
                                            JSON.parse(
                                                localStorage.getItem(
                                                    SAVED_RECIPES_PICTURES_WINREST
                                                )
                                            ) || {}
                                        if (isChecked) {
                                            handleChange(e)
                                        } else if (
                                            typedRecipesPics[concept] &&
                                            typedRecipesPics[concept][item.slug]
                                        ) {
                                            const newEvent = { ...e }
                                            newEvent.target.name = `recipe_${
                                                item.slug
                                            }-${
                                                typedRecipesPics[concept][
                                                    item.slug
                                                ]
                                            }`
                                            handleChange(newEvent)
                                        } else if (
                                            themes[concept].kiosks_background[
                                                item.slug
                                            ] !== undefined
                                        ) {
                                            const newEvent = { ...e }
                                            newEvent.target.name = `recipe_${item.slug}-${item.slug}`
                                            handleChange(newEvent)
                                        } else {
                                            this.setState({
                                                pickReciPic: item.slug,
                                            })
                                        }
                                    }

                                    return (
                                        <LineWrapper key={index}>
                                            <div>
                                                <Checkbox
                                                    name={`recipe_${name ||
                                                        item.slug}`}
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    onAction={handleCheckbox}
                                                    label={item.name}
                                                />
                                            </div>
                                            {isChecked && (
                                                <Button
                                                    onClick={() =>
                                                        this.setState({
                                                            pickReciPic:
                                                                item.slug,
                                                        })
                                                    }
                                                >
                                                    Modify
                                                </Button>
                                            )}
                                        </LineWrapper>
                                    )
                                })}
                            </KioskSelection>
                            <Separator />
                            <FormGroup>
                                <label>Day count:</label>
                                <input
                                    name="dayCount"
                                    type="number"
                                    value={dayCount}
                                    onChange={loading ? null : handleChange}
                                    disabled={
                                        displayMode === 'print' || loading
                                    }
                                    min="1"
                                />
                            </FormGroup>
                            <FormGroup>
                                <label>Start day:</label>
                                <select
                                    name="startDay"
                                    value={startDay}
                                    onChange={handleChange}
                                >
                                    {days.map((day, index) => (
                                        <option value={day} key={index}>
                                            {day}
                                        </option>
                                    ))}
                                </select>
                            </FormGroup>
                            {dayCount > 1 && (
                                <FormGroup>
                                    <label>Excluded days:</label>
                                    <select
                                        name="excludedDays"
                                        style={{ height: '120px' }}
                                        multiple
                                        onChange={setExcludedDays}
                                    >
                                        <option value="1">monday</option>
                                        <option value="2">tuesday</option>
                                        <option value="3">wednesday</option>
                                        <option value="4">thurday</option>
                                        <option value="5">friday</option>
                                        <option value="6">saturday</option>
                                        <option value="0">sunday</option>
                                    </select>
                                </FormGroup>
                            )}
                            <Separator />
                            <FormGroup>
                                <label>Mode:</label>
                                <select
                                    name="displayMode"
                                    value={displayMode}
                                    onChange={handleChange}
                                >
                                    {displayModes.map(
                                        (displayMode, index) =>
                                            displayMode.visible && (
                                                <option
                                                    value={displayMode.value}
                                                    key={index}
                                                >
                                                    {displayMode.name}
                                                </option>
                                            )
                                    )}
                                </select>
                            </FormGroup>
                            {(displayMode === 'kiosk' ||
                                displayMode === 'week') && (
                                <FormGroup>
                                    <label>Zoom:</label>
                                    <input
                                        name="zoom"
                                        type="number"
                                        step="0.01"
                                        value={zoom}
                                        onChange={handleChange}
                                    />
                                    <div />
                                    <small>ex: 1.05</small>
                                </FormGroup>
                            )}
                            {(displayMode === 'kiosk' ||
                                displayMode === 'week') && (
                                <FormGroup>
                                    <label>Print:</label>
                                    <div>
                                        <Checkbox
                                            name="print"
                                            type="checkbox"
                                            value={print}
                                            checked={print}
                                            onAction={handleChange}
                                        />
                                    </div>
                                </FormGroup>
                            )}
                            {print && displayMode !== 'week' && (
                                <Fragment>
                                    <FormGroup>
                                        <label>Orientation:</label>
                                        <select
                                            name="orientation"
                                            value={orientation}
                                            onChange={handleChange}
                                        >
                                            <option value="portrait">
                                                Portrait
                                            </option>
                                            <option value="landscape">
                                                Paysage
                                            </option>
                                        </select>
                                    </FormGroup>
                                    <FormGroup>
                                        <label>Size:</label>
                                        <select
                                            name="size"
                                            value={size}
                                            onChange={handleChange}
                                        >
                                            <option value="A4">A4</option>
                                            <option value="A5">A5</option>
                                        </select>
                                    </FormGroup>
                                    <FormGroup>
                                        <label>Show date:</label>
                                        <div>
                                            <Checkbox
                                                name="showDate"
                                                type="checkbox"
                                                value={showDate}
                                                checked={showDate}
                                                onAction={handleChange}
                                            />
                                        </div>
                                    </FormGroup>
                                </Fragment>
                            )}
                            <ActionLink>
                                <Link
                                    href={generateUrl()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Link
                                </Link>
                                {displayMode !== 'day' && print && (
                                    <ButtonDiv onClick={openPrintDialog}>
                                        Print
                                    </ButtonDiv>
                                )}
                            </ActionLink>
                        </Fragment>
                    )}

                {loading && <Loader small white />}
            </Fragment>
        )
    }
}

export default WinrestForm

const buttonStyle = `
    color: #fff;
    background-color: #1890ff;
    border-color: #1890ff;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
    line-height: 1.499;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 1px solid transparent;
    -webkit-box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    cursor: pointer;
    -webkit-transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    padding: 0 7px;
    font-size: 13px;
    border-radius: 4px;
    padding-left: 25px;
    padding-right: 25px;
`

export const Button = styled.button`
    ${buttonStyle};
`
export const Link = styled.a`
    ${buttonStyle}
    margin: 5px;
`
export const ButtonDiv = styled.div`
    ${buttonStyle}
    margin: 5px;
    user-select: none;
`

export const LineWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`

WinrestForm.propTypes = {
    // func
    handleChange: PropTypes.func,
    winrestApiFetcher: PropTypes.func,
    generateUrl: PropTypes.func,
    openPrintDialog: PropTypes.func,

    // boolean
    settingsDrawerOpen: PropTypes.bool,
    forceToday: PropTypes.bool,
    print: PropTypes.bool,

    // string
    winrestURL: PropTypes.string,
    siteId: PropTypes.string,
    pointOfSale: PropTypes.string,
    language: PropTypes.string,
    guestTypeSlug: PropTypes.string,
    mealTypeSlug: PropTypes.string,
    menuSlug: PropTypes.string,
    kiosk: PropTypes.string,
    displayMode: PropTypes.string,
    orientation: PropTypes.string,
    size: PropTypes.string,
    startDay: PropTypes.string,

    // array
    displayModes: PropTypes.array,
    recipes: PropTypes.array,
    days: PropTypes.array,

    // number
    zoom: PropTypes.number,
    dayCount: PropTypes.number,
}
